module.exports = __webpack_public_path__ + "static/media/piper-nudging-paw-2-w-background.8ca909a4.svg";